function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M303.21,427.24,299,420a1.47,1.47,0,0,0-2.56,0l-4.18,7.24a1.48,1.48,0,0,0,1.28,2.22h8.36A1.48,1.48,0,0,0,303.21,427.24Zm-6.06-5a.59.59,0,0,1,.59-.6h0a.6.6,0,0,1,.6.6v3.48a.6.6,0,0,1-.6.6h0a.59.59,0,0,1-.59-.6Zm1.14,5.85a.78.78,0,0,1-.55.23.69.69,0,0,1-.51-.21.74.74,0,0,1-.23-.54.78.78,0,0,1,.21-.51.75.75,0,0,1,.55-.23.73.73,0,0,1,.5.21.76.76,0,0,1,.24.55A.78.78,0,0,1,298.29,428.06Z",
  transform: "translate(-292.09 -419.26)"
});

function SvgIconPitLimit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.32 10.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPitLimit);
export default __webpack_public_path__ + "static/media/icon-pit-limit.69e0b0f4.svg";
export { ForwardRef as ReactComponent };